import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-sops',
  templateUrl: './sops.component.html',
  styleUrls: ['./sops.component.css']
})
export class SopsComponent implements OnInit {
    public itemsListSops: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSops() {
        this.itemsListSops = await this.datatask.Post(1838);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'sop':
                this.stateService?.go('sop', { sop_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadSops();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('sops', {
//        templateUrl: 'views/components/views/sops/sops.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'sopsService', function (stateService, sopsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListSops: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            let loadSops = function () {
//                sopsService.listSops().then(function (list) {
//                    angular.copy(list, vm.model.itemsListSops);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'sop':
//                        go({ sop_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSops();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
